<template>
    <div class="container">
        <div class="head">
            <div class="head_title">
                <img class="head_title_left" src="../assets/images/R+logo.png" alt="">
                <div class="head_title_right">
                    <img src="../assets/images/tel.png" alt="">
                    0571-56638573
                </div>
            </div>
            <div class="head_content">
                <div>
                    <img src="../assets/images/rujia_3.png" alt="">
                    <img src="../assets/images/rujia_4.png" alt="">
                </div>
                <p>
                    专注于泛时尚IP打造和商业化运作
                </p>
                <p>
                    业务主旨孵化、培养优质时尚内容，为全球新零售品牌客户提供多元化的整合营销方案
                </p>
                <!-- <div>点击进入</div> -->
            </div>
        </div>

        <div class="main">
            <div class="bg_c_f">
                <div class="mian_item">
                    <p>签约达人</p>
                    <van-swipe :height="269" :autoplay="5000" :show-indicators="false">
                        <van-swipe-item>
                            <div>
                                <img src="../assets/images/daren_1.png" alt="">
                                <p>E锅锅</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_2.png" alt="">
                                <p>白光组合</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_3.png" alt="">
                                <p>草匠匠匠匠</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_4.png" alt="">
                                <p>eLKO表哥</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_7.png" alt="">
                                <p>Lin张林超</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_9.png" alt="">
                                <p>十六铺双生花</p>
                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div>
                                <img src="../assets/images/daren_8.png" alt="">
                                <p>麦琪啦啦啦</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_10.png" alt="">
                                <p>颠点儿_</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_11.png" alt="">
                                <p>刘小呆</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_5.png" alt="">
                                <p>白兰花Michelia</p>
                            </div>
                            <div>
                                <img src="../assets/images/daren_6.png" alt="">
                                <p>仙爷种草机</p>
                            </div>
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <div class="mian_item">
                    <p>广告形式</p>
                    <div class="mian_item_content">
                        <div>
                            <div>
                                热销营销
                            </div>
                            <div>
                                销售引流
                            </div>
                            <div>
                                微电影
                            </div>
                            <div>
                                附增值服务
                            </div>
                            <div>
                                定制软广
                            </div>
                        </div>
                        <div>
                            <div>
                                植入软广
                            </div>
                            <div>
                                品牌联名
                            </div>
                            <div>
                                线下活动
                            </div>
                            <div>
                                TVC
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mian_item">
                    <p>核心优势</p>
                    <div class="main_item_content_advantage">
                        <img src="../assets/images/hx_1.png" alt="">
                        <div>
                            <p>达人经济优势 </p>
                            <p>结合达人特点提供专业经纪服务，量身定制达人发展规划，建立完善的成长体系。</p>
                        </div>
                    </div>
                    <div class="main_item_content_advantage">
                        <img src="../assets/images/hx_2.png" alt="">
                        <div>
                            <p>商业价值最大化 </p>
                            <p>抖音、微博等平台战略合作伙伴，通过多平台流量聚合，实现红人商业价值最大化。</p>
                        </div>
                    </div>
                    <div class="main_item_content_advantage">
                        <img src="../assets/images/hx_3.png" alt="">
                        <div>
                            <p>全方位营销服务 </p>
                            <p>为品牌定制深洞察、易传播、强互动的创意内容， 以social化广告为品牌提供从形象传播到销售转化的全方位营销服务。</p>
                        </div>
                    </div>
                    <div class="main_item_content_advantage">
                        <img src="../assets/images/hx_4.png" alt="">
                        <div>
                            <p>聚焦时尚领域 </p>
                            <p>聚焦深耕时尚领域人群，集中火力在时尚领域内制造大声量传播。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg_c_b">
                <div class="mian_item">
                    <p>合作伙伴</p>
                    <img src="../assets/images/hzhb.png" alt="">
                </div>
            </div>
        </div>
        <common-footer></common-footer>

        <div class="top" v-show="isShow" @click="goToTop"></div>
    </div>
</template>

<script>
import commonFooter from '../components/common-footer.vue'

export default {
    data() {
        return {
            isShow: false
        }
    },
    components: {
        commonFooter
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop)
    },
    methods: {
        scrollToTop() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.scrollTop = scrollTop
            if (scrollTop > 100) {
                this.isShow = true;
            } else {
                this.isShow = false;
            }
        },
        goToTop() {
            document.documentElement.scrollTop = document.body.scrollTop = 0
        }
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop);
    }
}
</script>

<style scoped>
.head {
    height: 353px;
    background-image: url("../assets/images/im_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.head_title {
    height: 55px;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
}
.head_title_left {
    width: 102.5px;
    height: 55px;
    display: block;
}
.head_title_right {
    font-size: 12px;
    color: #ffffff;
    letter-spacing: 0;
    display: flex;
    align-items: center;
}
.head_title_right > img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}

.head_content {
    padding: 50px 36.5px 40px 38.5px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.head_content > div:nth-child(1) {
    width: 300px;
    height: 68px;
}
.head_content > div:nth-child(1) > img {
    width: 300px;
    height: 34px;
    display: block;
}
.head_content > div:nth-child(1) > img:nth-child(1) {
    animation: head_content_img_left_enter 2s;
}
.head_content > div:nth-child(1) > img:nth-child(2) {
    animation: head_content_img_right_enter 2s;
}
.head_content > p:nth-child(2) {
    font-size: 20px;
    letter-spacing: 0;
    text-align: center;
    padding: 30px 0 8px;
}
.head_content > p:nth-child(3) {
    font-size: 12px;
    letter-spacing: 0;
    line-height: 16px;
    padding-bottom: 16px;
}
.head_content > div:nth-child(4) {
    width: 77.5px;
    height: 24px;
    line-height: 22px;
    text-align: center;
    border: 1px solid #ffffff;
    border-radius: 13px;
    font-size: 12px;
    box-sizing: border-box;
}

.bg_c_f {
    background-color: #fff;
    padding: 24px 16px 40px;
}

.bg_c_b {
    background-color: #3b5adc;
    padding: 24px 16px 40px;
}

.mian_item > p {
    font-size: 20px;
    color: #1f1f1f;
    letter-spacing: 0;
    text-align: center;
    padding-bottom: 16px;
}

.bg_c_b > .mian_item > p {
    font-size: 20px;
    color: #fff;
    letter-spacing: 0;
    text-align: center;
    padding-bottom: 16px;
}

.mian_item > img {
    width: 343px;
    height: 166px;
    display: block;
}
.van-swipe-item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 40px;
}
.van-swipe-item > div {
    width: 114px;
    height: 122.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #1f1f1f;
}
.van-swipe-item > div:nth-child(1),
.van-swipe-item > div:nth-child(2),
.van-swipe-item > div:nth-child(3) {
    margin-bottom: 24px;
}
.van-swipe-item > div > img {
    width: 90px;
    height: 90px;
    margin-bottom: 16px;
}
.van-swipe-item > div > p {
    font-size: 12px;
}

.mian_item_content {
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;
}
.mian_item_content > div {
    width: 165.5px;
}
.mian_item_content > div > div {
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
}
.mian_item_content > div:nth-child(1) > div:nth-child(1) {
    height: 75px;
    line-height: 75px;
    background-image: url("../assets/images/gg_1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-bottom: 12px;
}
.mian_item_content > div:nth-child(1) > div:nth-child(2) {
    height: 90px;
    line-height: 90px;
    background-color: #96b8f0;
    margin-bottom: 12px;
}

.mian_item_content > div:nth-child(1) > div:nth-child(3) {
    height: 115px;
    line-height: 115px;
    background-image: url("../assets/images/gg_3.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-bottom: 12px;
}

.mian_item_content > div:nth-child(1) > div:nth-child(4) {
    height: 75px;
    line-height: 75px;
    background-color: #f9b2c7;
    margin-bottom: 12px;
}

.mian_item_content > div:nth-child(1) > div:nth-child(5) {
    height: 100px;
    line-height: 100px;
    background-image: url("../assets/images/gg_4.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.mian_item_content > div:nth-child(2) > div:nth-child(1) {
    height: 123.5px;
    line-height: 123.5px;
    background-color: #fbbd69;
    margin-bottom: 12px;
}
.mian_item_content > div:nth-child(2) > div:nth-child(2) {
    height: 120px;
    line-height: 120px;
    background-image: url("../assets/images/gg_2.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-bottom: 12px;
}
.mian_item_content > div:nth-child(2) > div:nth-child(3) {
    height: 85px;
    line-height: 85px;
    background-color: #9fd2b6;
    margin-bottom: 12px;
}
.mian_item_content > div:nth-child(2) > div:nth-child(4) {
    height: 138.5px;
    line-height: 138.5px;
    background-image: url("../assets/images/gg_5.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.main_item_content_advantage {
    display: flex;
    padding: 10px;
    border: 1px solid #e4e4e4;
    box-sizing: border-box;
    margin-bottom: 12px;
}
.main_item_content_advantage:nth-child(2),
.main_item_content_advantage:nth-child(3),
.main_item_content_advantage:nth-child(5) {
    height: 77px;
}
.main_item_content_advantage:nth-child(4) {
    height: 93px;
}
.main_item_content_advantage > img {
    width: 22px;
    height: 22px;
    margin-right: 10px;
}
.main_item_content_advantage > div {
    flex: 1;
}
.main_item_content_advantage > div > p:nth-child(1) {
    font-size: 14px;
    color: #1f1f1f;
    letter-spacing: 0;
    padding-bottom: 5px;
}
.main_item_content_advantage > div > p:nth-child(2) {
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    line-height: 16px;
}
.top {
    width: 40px;
    height: 40px;
    position: fixed;
    right: 16px;
    bottom: 50px;
    background-image: url("../assets/images/Top .png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

@keyframes head_content_img_left_enter {
    0% {
        transform: translateX(-300px);
    }
    100% {
        transform: translateX(0px);
    }
}
@keyframes head_content_img_right_enter {
    0% {
        transform: translateX(300px);
    }
    100% {
        transform: translateX(0px);
    }
}
</style>